@let blok = block();

<img [ngSrc]="blok.asset.filename" width="20" height="20" [alt]="blok.asset.alt" class="mr-4">
<span class="break-words">{{ blok.text }}</span>
